module.exports = __webpack_public_path__ + "static/media/dhb.02dafc3f.png";